import React from 'react';
import SettingField from 'components/Fields/ReduxForm/SettingField';
import {
  Field,
  reduxForm,
  change,
  isDirty,
  formValueSelector,
} from 'redux-form';
import moment from 'moment';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { businessCity, businessZipcode, businessKecamatan } from 'actions';
import {
  askReactivateOutlet,
  askReactivateOutletWithoutPay,
} from 'actions/outletPages/list';
import PhoneNumberField from 'components/Fields/ReduxForm/PhoneNumberField';

import {
  resetKybCityDropdown,
  resetKybKecamatanDropdown,
  resetKybZipcodeDropdown,
} from 'actions/kyb';
import SwitchField from 'components/Fields/ReduxForm/SwitchField';
import withFeatureFlag from 'hocs/withFeatureFlags';
import * as clevertapOutletsList from 'clevertap/outlets/list';
import classNames from 'classnames';
import CustomOutletDropdown from '../CustomOutletDropdown/CustomOutletDropdown';
import styles from './OutletForm.css';
import SaudagarInfoModal from '../SaudagarInfoModal';

const validate = values => {
  const errors = {};
  const FIELD_REQUIRED_ERROR = 'This field is required';

  if (!values.name || values.name.trim() === '') {
    errors.name = FIELD_REQUIRED_ERROR;
  }

  if (!values.address || values.address.trim() === '') {
    errors.address = FIELD_REQUIRED_ERROR;
  }

  if (!values.phone) {
    errors.phone = FIELD_REQUIRED_ERROR;
  }

  if (!values.province) {
    errors.province = FIELD_REQUIRED_ERROR;
  }

  if (!values.city) {
    errors.city = FIELD_REQUIRED_ERROR;
  }

  if (!values.kecamatan) {
    errors.kecamatan = FIELD_REQUIRED_ERROR;
  }

  if (!values.postal) {
    errors.postal = FIELD_REQUIRED_ERROR;
  }

  if (values.outletToggle && !values.clonedOutlet) {
    errors.clonedOutlet = FIELD_REQUIRED_ERROR;
  }

  return errors;
};

const MIN_OUTLET_NUMBER = 0;

const renderOutletStatus = outlet => {
  const endDate = moment(outlet.end_date);
  const todayDate = moment();
  if (!endDate.isSameOrAfter(todayDate)) {
    return <span className={styles['outlet-inactive']}>Expired</span>;
  }
  return <span className={styles['outlet-active']}>Active</span>;
};

const renderSelectField = ({
  input,
  meta: { touched, error },
  children,
  ...rest
}) => (
  <div>
    <div>
      <select
        {...input}
        {...rest}
        className={`form-control ${
          touched && error ? styles['input-error'] : ''
        }`}
      >
        {children}
      </select>
      <small className={styles.error}>{touched ? error : ''}</small>
    </div>
  </div>
);

class OutletForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      toggleState: false,
      isShowingAssociationModal: false,
    };
  }

  handleProvinceChange = e => {
    const province = e.target.value;
    const provinceId = this.props.moka.businessProvinceState[province];
    this.props.dispatch(resetKybCityDropdown());
    this.props.dispatch(resetKybKecamatanDropdown());
    this.props.dispatch(resetKybZipcodeDropdown());
    this.props.dispatch(change('outlet', 'city', null));
    this.props.dispatch(change('outlet', 'kecamatan', null));
    this.props.dispatch(change('outlet', 'zipcode', null));
    if (provinceId !== undefined && provinceId !== null) {
      this.props.dispatch(businessCity(provinceId));
    }
  };

  handleCityChange = e => {
    const city = e.target.value;
    const cityId = this.props.moka.businessCityState[city];
    this.props.dispatch(resetKybKecamatanDropdown());
    this.props.dispatch(resetKybZipcodeDropdown());
    this.props.dispatch(change('outlet', 'kecamatan', null));
    this.props.dispatch(change('outlet', 'zipcode', null));
    if (cityId !== undefined && cityId !== null) {
      this.props.dispatch(businessKecamatan(cityId));
    }
  };

  handleKecamatanChange = e => {
    const kecamatan = e.target.value;
    const kecamatanId = this.props.moka.businessKecamatanState[kecamatan];
    this.props.dispatch(resetKybZipcodeDropdown());
    this.props.dispatch(change('outlet', 'zipcode', null));
    if (kecamatanId !== undefined && kecamatanId !== null) {
      this.props.dispatch(businessZipcode(kecamatanId));
    }
  };

  showAssociationModal = () => {
    this.setState({
      isShowingAssociationModal: true,
    });
  };

  hideAssociationModal = () => {
    this.setState({
      isShowingAssociationModal: false,
    });
  };

  render() {
    const {
      handleSubmit,
      editedOutlet,
      disableSaveOutletButton,
      moka,
      association,
    } = this.props;
    const { isShowingAssociationModal } = this.state;
    const {
      businessProvinceState,
      businessCityState,
      businessZipcodeState,
      businessKecamatanState,
    } = moka;
    const provinceIdList = Object.keys(businessProvinceState);
    const cityIdList = Object.keys(businessCityState);
    const kecamatanIdList = Object.keys(businessKecamatanState);
    const todayDate = moment();

    const showAssociationNotice = !!association;
    const immutable = false;

    return (
      <form onSubmit={handleSubmit} className={styles.wrapper}>
        {isShowingAssociationModal && (
          <SaudagarInfoModal
            onClose={this.hideAssociationModal}
            moka={association.moka}
            saudagar={association.saudagar}
          />
        )}
        <div className={`${styles['field-wrapper']} outlet-field-wrapper`}>
          {showAssociationNotice && (
            <div
              className={classNames(
                'alert alert-info',
                styles['association-notice']
              )}
            >
              <div>
                <i className="glyphicon glyphicon-exclamation-sign text-info" />
                &nbsp; This outlet is associated with a GoBiz account
              </div>
              <button
                type="button"
                className="btn btn-link"
                onClick={this.showAssociationModal}
              >
                <b>Details</b>
              </button>
            </div>
          )}

          {editedOutlet && (
            <div className="row">
              <div className="col-lg-12">
                <p>
                  Outlet Status&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;&nbsp;
                  {renderOutletStatus(editedOutlet)}
                </p>
              </div>
            </div>
          )}
          <Field name="id" component="input" type="hidden" />
          <Field name="businessId" component="input" type="hidden" />
          <div className="row">
            <div className="col-lg-12">
              <div className="form-group">
                <Field
                  name="name"
                  component={SettingField}
                  placeholder="Outlet Name"
                  dis={immutable}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="form-group">
                <Field
                  name="address"
                  component={SettingField}
                  placeholder="Address"
                  dis={immutable}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="form-group">
                <Field
                  component={PhoneNumberField}
                  name="phone"
                  type="tel"
                  placeholder="812"
                  disabled={immutable}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="form-group">
                <Field
                  component={renderSelectField}
                  onChange={this.handleProvinceChange}
                  name="province"
                  disabled={immutable}
                >
                  <option key={0} value="">
                    Province
                  </option>
                  {provinceIdList.map((name, index) => (
                    <option value={name} key={index}>
                      {name}
                    </option>
                  ))}
                </Field>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="form-group">
                <Field
                  component={renderSelectField}
                  onChange={this.handleCityChange}
                  name="city"
                  disabled={immutable}
                >
                  <option key={0} value="">
                    City / Kabupaten
                  </option>
                  {cityIdList.map((name, index) => (
                    <option value={name} key={index}>
                      {name}
                    </option>
                  ))}
                </Field>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="form-group">
                <Field
                  component={renderSelectField}
                  onChange={this.handleKecamatanChange}
                  name="kecamatan"
                  disabled={immutable}
                >
                  <option key={0} value="">
                    Kecamatan
                  </option>
                  {kecamatanIdList.map((name, index) => (
                    <option value={name} key={index}>
                      {name}
                    </option>
                  ))}
                </Field>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="form-group">
                <Field
                  component={renderSelectField}
                  name="postal"
                  disabled={immutable}
                >
                  <option key={0} value="">
                    Postal code
                  </option>
                  {businessZipcodeState.map(option => (
                    <option value={option.code} key={option.id}>
                      {option.code}
                    </option>
                  ))}
                </Field>
              </div>
            </div>
          </div>

          {this.props.showCloneOutletOption &&
          this.props.isCloningEligible &&
          this.props.hasCloneOutletFeatureFlag ? (
            <div>
              <div className={styles['form-clone']}>
                <div className={styles['clone-toggle-lbl']}>
                  <span>CLONE OUTLET</span>
                  <span className={styles.switchbox}>
                    <Field
                      component={SwitchField}
                      disabled={this.props.usedOutletSlots <= MIN_OUTLET_NUMBER}
                      name="outletToggle"
                      type="checkbox"
                      onChange={this._onChangeToggle}
                    />
                  </span>
                  <hr />
                </div>
              </div>

              {this.props.showOutletList ? (
                <div>
                  <Field
                    component={CustomOutletDropdown}
                    className="selectOutlets"
                    name="clonedOutlet"
                    options={this._formatOutlets(
                      this.props.cloneOutletDropdown.outlets
                    )}
                    outlets={this.props.cloneOutletDropdown.outlets}
                    onChange={this._onChangeCloneOutlet}
                    placeholder="Search"
                  />
                </div>
              ) : (
                <p className={styles['clone-wording']}>
                  Copy library components (item library, modifiers, categories,
                  etc.) from existing outlet to this outlet.
                </p>
              )}
            </div>
          ) : null}
        </div>
        <div className={styles.footer}>
          <span className="pull-left">
            {editedOutlet &&
              !moment(editedOutlet.end_date).isSameOrAfter(todayDate) && (
                <button
                  className="btn btn-primary"
                  type="button"
                  onClick={this._onClickReactivateOutlet}
                >
                  Reactivate
                </button>
              )}
          </span>
          <span className="pull-right">
            <button
              className="btn btn-default"
              type="button"
              style={{ marginRight: '10px' }}
              onClick={this._onClickCancel}
            >
              Cancel
            </button>
            <button
              className="btn btn-primary"
              type="submit"
              disabled={disableSaveOutletButton}
            >
              Save
            </button>
          </span>
        </div>
      </form>
    );
  }

  _onClickCancel = () => {
    this.props.onClickCancel();
  };

  _onClickReactivateOutlet = () => {
    const { editedOutlet, dispatch, outletSlots, usedOutletSlots } = this.props;
    if (outletSlots > usedOutletSlots) {
      dispatch(askReactivateOutletWithoutPay(editedOutlet));
    } else {
      dispatch(askReactivateOutlet(editedOutlet));
    }
  };

  _onChangeToggle = () => {
    if (!this.state.toggleState) {
      this.setState({
        toggleState: true,
      });
      clevertapOutletsList.cloneOutletOn();
    } else {
      this.setState({
        toggleState: false,
      });
      clevertapOutletsList.cloneOutletOff();
      change('', 'clonedOutlet', '');
    }
  };

  _onChangeCloneOutlet = (val, newVal) => {
    const { outlets } = this.props.cloneOutletDropdown;
    let selected = null;
    outlets.forEach((outlet, index) => {
      if (newVal === outlet.id) {
        selected = outlets[index];
      }
    });
    if (selected) {
      change('', 'clonedOutlet', selected.id);
    }
  };

  _formatOutlets = outlets => {
    const formatOutlet = [];
    outlets.map(function(outlet) {
      const endDate = moment(outlet.end_date);
      const todayDate = moment();
      if (outlet.id > 0 && endDate.isSameOrAfter(todayDate)) {
        formatOutlet.push({ value: outlet.id, label: outlet.name });
      }
    });
    return formatOutlet;
  };
}

const selector = formValueSelector('outlet');

OutletForm.propTypes = {
  onClickCancel: PropTypes.func,
  onSubmit: PropTypes.func,
  dispatch: PropTypes.func,
  isDirtyForm: PropTypes.bool,
  editedOutlet: PropTypes.object,
};

const mapForm = {
  form: 'outlet',
  touchOnBlur: false,
  touchOnChange: true,
  validate,
};

function mapStateTopProps(state) {
  const { moka } = state;
  const {
    outletSlots,
    usedOutletSlots,
    outlets,
    showCloneOutletOption,
    cloneOutletDropdown,
    isCloningEligible,
  } = state.outletPages.list;
  return {
    moka,
    isDirtyForm: isDirty('outlet')(state),
    editedOutlet: state.outletPages.list.outletDetail,
    disableSaveOutletButton: state.outletPages.list.disableSaveOutletButton,
    outletSlots,
    usedOutletSlots,
    outlets,
    showCloneOutletOption,
    showOutletList: selector(state, 'outletToggle'),
    cloneOutletDropdown,
    isCloningEligible,
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

const connected = connect(
  mapStateTopProps,
  mapDispatchToProps
)(reduxForm(mapForm)(OutletForm));

const mapFlagToProps = flags => {
  return {
    hasCloneOutletFeatureFlag: flags.cloneOutletFeatureFlag,
  };
};

export default withFeatureFlag(mapFlagToProps)(connected);
